import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./contactHistoryPageTour.css";

function isDesktopLayout() {
  if (typeof window === "undefined" || !window.matchMedia) return true;
  return window.matchMedia("(min-width: 768px)").matches;
}

/**
 * Product tour — trang /crm/contact_history.
 * Các bước gắn qua [data-tour="..."] trong ContactHistoryListPage và ContactFilter.
 */
export function startContactHistoryPageTour() {
  const lg = isDesktopLayout();

  const segments = [
    {
      selector: '[data-tour="contact-history-header"]',
      title: "Lịch sử liên hệ",
      description:
        "Theo dõi mọi tương tác với khách: gọi điện, email, Zalo… Dữ liệu gắn với chi nhánh và khách hàng trong CRM.",
      side: "bottom",
    },
    {
      selector: '[data-tour="contact-filter"]',
      title: "Tìm kiếm, lọc và ghi nhận",
      description: lg
        ? "Tìm theo từ khóa (có độ trễ nhẹ). Mở Lọc nâng cao để chọn chi nhánh, hình thức, khoảng ngày. Xuất CSV hoặc bấm Ghi nhận liên hệ để mở form — trong form có thể đặt ngày hẹn liên hệ lại để khách xuất hiện ở mục (1) bên dưới."
        : "Tìm nhanh bằng từ khóa; bấm biểu tượng cài đặt để lọc chi nhánh và ngày. Nút + nổi ở góc dưới mở form ghi nhận — trong form có thể chọn ngày hẹn liên hệ lại.",
      side: "bottom",
    },
    {
      selector: '[data-tour="contact-stats"]',
      title: "Thống kê nhanh",
      description:
        "Bốn ô số theo bộ lọc hiện tại: tổng liên hệ, liên hệ tháng này, số cuộc còn lịch hẹn lại, và liên hệ qua gọi điện.",
      side: "bottom",
    },
    {
      selector: '[data-tour="contact-reminder-section"]',
      title: "Liên lạc cần xử lý hôm nay / quá hạn",
      description:
        "Chỉ các khách có ngày hẹn liên hệ lại là hôm nay hoặc đã quá hạn. Bấm “Xem tất cả lịch hẹn” để mở toàn bộ lịch (kể cả ngày sau).",
      side: "top",
    },
    {
      selector: '[data-tour="contact-completed-table"]',
      title: "Liên lạc đã hoàn thành",
      description:
        "Các lần liên hệ không còn lịch hẹn tiếp theo (hoặc đã xử lý xong). Bấm tiêu đề cột để sắp xếp; kéo mép cột để chỉnh độ rộng. Bấm một dòng để xem chi tiết.",
      side: "top",
    },
    {
      selector: '[data-tour="contact-pagination"]',
      title: "Phân trang",
      description:
        "Chuyển trang và đổi số bản ghi mỗi trang. Dữ liệu (1) và (2) cùng nguồn đã lọc; phân trang áp dụng cho toàn bộ danh sách trả về.",
      side: "top",
    },
  ];

  const steps = [
    {
      popover: {
        title: "Hướng dẫn sử dụng",
        description:
          "Lần lượt: thanh tìm kiếm & ghi nhận → thống kê → lịch hẹn sắp tới → bảng lịch sử. Bấm Tiếp để xem từng vùng; X để thoát.",
        side: "over",
        align: "center",
      },
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (el) {
      steps.push({
        element: el,
        popover: {
          title: seg.title,
          description: seg.description,
          side: seg.side,
        },
      });
    }
  }

  if (steps.length <= 1) {
    window.alert(
      "Chưa tải được các vùng giao diện để hướng dẫn. Hãy tải lại trang và thử lại."
    );
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "contact-history-tour-popover",
    onPopoverRender: (popover) => {
      popover.wrapper?.setAttribute?.("lang", "vi");
    },
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
